/**
 * localStorage keys tied to the authenticated session (not app preferences like `locale`).
 * Keep in sync with the modules that read/write them.
 */
export const SELECTED_ORGANIZATION_ID_KEY = 'selected_organization_id'
